// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps, ID, ICurriculum } from "../../../constants";

const actionGetCurriculums = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_CURRICULUMS),
  api: api.getCurriculums,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

const actionGetCurriculumById = (
  payload: ID,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.getCurriculumById,
  callback,
});

const actionCreateCurriculum = (
  payload: ICurriculum,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.createCurriculum,
  callback,
});

const actionUpdateCurriculum = (
  payload: ICurriculum,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.updateCurriculum,
  callback,
});

const actionDeleteCurriculum = (
  payload: { id: ID },
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.deleteCurriculum,
  payload: { data: payload },
  callback,
});


export {
  actionGetCurriculumById,
    actionDeleteCurriculum,
    actionUpdateCurriculum,
    actionGetCurriculums,
    actionCreateCurriculum
};